import { render } from "./League.vue?vue&type=template&id=14b1ca1d&scoped=true"
import script from "./League.vue?vue&type=script&lang=js"
export * from "./League.vue?vue&type=script&lang=js"

import "./League.vue?vue&type=style&index=0&id=14b1ca1d&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b1ca1d"]])

export default __exports__